import { apiCall } from "./servicesCall";

export const COMPANY_SERVICES = {
  profile(data) {
    return apiCall("/company", data);
  },
  events(data) {
    return apiCall("/company/events", data);
  },
  eventsLanding(data) {
    return apiCall("/company/events/landing", data);
  },

  posts(data) {
    return apiCall("/company/posts", data);
  },
  postsView(data) {
    return apiCall("/company/post/view", data);
  },
  membersList(data) {
    return apiCall("/company/members/list", data);
  },
};
